/* Gift lines: pure policy shared by the local tests and storefront controller.
   Client policy is UX; zero-price variants still require ERP review for theme bypasses. */
(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.JadoreGiftPolicy = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, () => {
  'use strict';
  const tiers = ['600', '1500'];
  const gift = (item, meta) => (/^JP-G/.test(item.sku || '') || (meta[String(item.product_id)]?.tags || []).includes('prezent-koszyk'));
  const excluded = (item, meta) => {
    const m = meta[String(item.product_id)] || {};
    return gift(item, meta) || item.gift_card || /bon|voucher|zabieg|usług|pakiet|prezent|opakowanie/.test((m.type || '').toLowerCase()) ||
      ['Lira Clinical', 'Osmosis Beauty'].includes(item.vendor) ||
      (m.tags || []).some(t => ['wysylka-pdf', 'prezent-koszyk', 'prezent-89', 'tylko-gabinet'].includes(t));
  };
  function state(cart, meta, config, rate) {
    let eligible = 0, giftSubtotal = 0, paidCount = 0;
    for (const item of cart.items) {
      if (!meta[String(item.product_id)]) throw new Error('Missing product metadata');
      if (gift(item, meta)) giftSubtotal += item.final_line_price;
      else paidCount += item.quantity;
      if (!excluded(item, meta)) eligible += item.final_line_price;
    }
    const sub = cart.items_subtotal_price;
    // #93: proportional allocation of cart-level discounts, rounded down as Liquid.
    const allocate = amount => sub > 0 && cart.total_price < sub
      ? Number(BigInt(amount) * BigInt(cart.total_price) / BigInt(sub)) : amount;
    const p = allocate(eligible); // Products after line and proportional cart discounts; no shipping.
    const d = Math.max(0, cart.total_price - allocate(giftSubtotal));
    const knownRate = cart.currency === 'PLN' && config.country === 'PL';
    const threshold = amount => cart.currency === 'PLN' ? amount : Math.ceil(amount * rate / 100) * 100;
    const active = config.enabled && config.promo && paidCount > 0 && knownRate;
    return { p, d, paidCount, allowed: {
      '600': !!active && p >= threshold(config.prog1),
      '1500': !!active && config.prog2on && p >= threshold(config.prog2)
    }};
  }
  function plan(cart, meta, config, rate) {
    const s = state(cart, meta, config, rate), updates = {}, selected = {};
    const catalog = config.catalog || [];
    for (const item of cart.items) {
      if (!gift(item, meta)) continue;
      const c = catalog.find(c => String(c.id) === String(item.variant_id));
      const valid = c && s.allowed[c.tier] && c.available && c.price === 0 && item.original_price === 0 && item.final_line_price === 0 && !item.selling_plan_allocation;
      if (!valid || selected[c.tier]) updates[item.key] = 0;
      else {
        selected[c.tier] = c;
        if (item.quantity !== 1) updates[item.key] = 1;
      }
    }
    const attributes = { Prezent: selected['1500'] ? '2' : selected['600'] ? '1' : '',
      'Prezent 600': selected['600']?.name || '', 'Prezent 1500': selected['1500']?.name || '' };
    const changedAttributes = {};
    for (const [key, value] of Object.entries(attributes)) {
      if ((cart.attributes?.[key] || '') !== value) changedAttributes[key] = value;
    }
    return { ...s, updates, selected, attributes, changedAttributes };
  }
  return { tiers, gift, excluded, state, plan };
});
